var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import * as UnlinkedApplicationForm from "../../../components/UnlinkedApplicationForm";
import { Button, DateTextField } from "@savvyinsure/react-ui";
import AppBody from "../../../components/AppBody";
import Header from "../../../components/Header";
import { PHASE } from "../../../routeConfig";
import { PivotReason } from "../../../features/applicant/applicantSlice";
import { completedPage } from "../../../lib/Avo";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
import { savePolicyExpiration } from "../../../features/unlinked-application/unlinkedApplicationSlice";
import useAppDispatch from "../../../hooks/useAppDispatch";
import useAppSelector from "../../../hooks/useAppSelector";
import { useForm } from "react-hook-form";
import useMemoryHistory from "../../../hooks/useMemoryHistory";
dayjs.extend(customParseFormat);
export default function UnlinkedApplicationAutoPolicyExpiration() {
    var _a;
    var defaultPolicyExpiration = useAppSelector(function (state) { return state.unlinkedApplication.auto.policyExpiration; });
    var _b = useForm({
        defaultValues: {
            policyExpiration: defaultPolicyExpiration,
        },
    }), register = _b.register, errors = _b.formState.errors, handleSubmit = _b.handleSubmit;
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var nextRoute = useAppSelector(function (state) {
        var isBundleAutoFromHome = state.applicant.bundlePivotReason === PivotReason.BundleAutoFromHome;
        if (isBundleAutoFromHome) {
            return PHASE.UNLINKED_APPLICATION_HOMEOWNERS_POLICY_HOLDER;
        }
        return PHASE.UNLINKED_APPLICATION_AUTO_POLICY_HOLDER_ADDRESS;
    });
    var dispatch = useAppDispatch();
    var push = useMemoryHistory().push;
    var policyExpirationInput = register("policyExpiration", {
        required: true,
        minLength: 10,
        validate: {
            isValidDate: function (v) {
                return dayjs(v, "MM/DD/YYYY", true).isValid() || "Please enter a valid date";
            },
        },
    });
    var onSubmit = handleSubmit(function (data) {
        var selectedOption = data.policyExpiration;
        dispatch(savePolicyExpiration(selectedOption));
        completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: selectedOption, optionSelected: selectedOption }));
        push(nextRoute);
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { showDropShadow: true },
            React.createElement(UnlinkedApplicationForm.Progress, null)),
        React.createElement(AppBody, { as: "form", onSubmit: onSubmit },
            React.createElement(UnlinkedApplicationForm.ScrollingContainer, null,
                React.createElement(UnlinkedApplicationForm.Header, { className: "mb-1 mt-6" }, "When does your current policy expire?"),
                React.createElement("p", { className: "mb-6" }, "An estimate is okay"),
                React.createElement(DateTextField, __assign({}, policyExpirationInput, { id: "policy-expiration", label: "Policy Expiration Date (MM/DD/YYYY)", format: "##/##/####", placeholder: "mm/dd/yyyy", mask: "", "aria-invalid": Boolean(errors === null || errors === void 0 ? void 0 : errors.policyExpiration), errorMessage: (_a = errors.policyExpiration) === null || _a === void 0 ? void 0 : _a.message, defaultValue: defaultPolicyExpiration })),
                React.createElement(Button, { className: "mb-3 mt-6" }, "Continue"),
                React.createElement(Button, { variant: "outlined", type: "button", onClick: function (ev) {
                        var selectedOption = ev.currentTarget.textContent;
                        completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: selectedOption, optionSelected: selectedOption }));
                        push(nextRoute);
                    } }, "Skip")))));
}
